import ganttChartStyles from "../../styles/ganttChart/ganttChart.module.css";
import colors from "../../utils/colors";
const KpiWrapper = ({
  value,
  showColoredChip,
  children,
  id,
  compact,
}: {
  value: number;
  showColoredChip?: boolean;
  children?: React.ReactNode;
  id?: string;
  compact?: boolean;
}) => {
  return (
    <div className={compact ? "" : ganttChartStyles.kpiChip} id={id}>
      {showColoredChip && (
        <div
          className={ganttChartStyles.kpiBullet}
          style={{
            backgroundColor: colors.getBackgroundColor(value),
          }}
        ></div>
      )}
      {children}
      {!compact && (value ? value : 0)}
    </div>
  );
};

export default KpiWrapper;
